import React from 'react';
import styled from 'styled-components';
import appleStore from "./images/appleStore-fs8.png.js";
import appleStore2x from "./images/appleStore@2x-fs8.png.js";
import googlePlay from "./images/googlePlay-fs8.png.js";
import googlePlay2x from "./images/googlePlay@2x-fs8.png.js";
var AppLink = styled.a.withConfig({
  displayName: "AppLinks__AppLink",
  componentId: "sc-1l9ao0x-0"
})(["margin:0 10px;"]);
var Wrapper = styled.div.withConfig({
  displayName: "AppLinks__Wrapper",
  componentId: "sc-1l9ao0x-1"
})(["display:flex;justify-content:center;"]);
var AppImage = styled.img.withConfig({
  displayName: "AppLinks__AppImage",
  componentId: "sc-1l9ao0x-2"
})(["width:118.2px;height:34.2px;"]);

function AppLinks(props) {
  return /*#__PURE__*/React.createElement(Wrapper, props, /*#__PURE__*/React.createElement(AppLink, {
    href: "https://itunes.apple.com/se/app/blocket/id323710525"
  }, /*#__PURE__*/React.createElement(AppImage, {
    alt: "H\xE4mta i App Store",
    src: appleStore,
    srcSet: "".concat(appleStore2x, " 2x")
  })), /*#__PURE__*/React.createElement(AppLink, {
    href: "https://play.google.com/store/apps/details?id=se.appcorn.Blocket"
  }, /*#__PURE__*/React.createElement(AppImage, {
    alt: "Ladda ned p\xE5 Google Play",
    src: googlePlay,
    srcSet: "".concat(googlePlay2x, " 2x")
  })));
}

export default AppLinks;
//# sourceMappingURL=AppLinks.js.map